import 'app/agriculture/routes/SetDefaultMapView/SetDefaultMapView.scss';
import { Portal } from '@mui/material';
import { Button } from 'app/agriculture/components/Button/Button';
import { useNavigate } from 'react-router-dom';
import { useFarmPath } from 'app/agriculture/router/useFarmPath';
import { useFarm } from 'app/agriculture/hooks/useFarm/useFarm';
import { useContext } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { AgricultureToastType } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { getViewerPosition } from 'app/agriculture/routes/BackOffice/FarmCreate/components/getViewerPosition';
import { RotatableBoundingRect } from 'app/agriculture/routes/SetDefaultMapView/RotatableBoundingRect';

export function SetDefaultMapView() {
    const navigate = useNavigate();
    const farmPath = useFarmPath();
    const { updateFarm } = useFarm();
    const { mapService, agricultureToastService } = useContext(ServicesContext);

    return (
        <Portal>
            <div className="SetDefaultMapView">
                <div className="SetDefaultMapView__bounds">
                    <div className="SetDefaultMapView__bounds__row">
                        <RotatableBoundingRect rotation={180} />
                        <RotatableBoundingRect rotation={270} />
                    </div>
                    <div className="SetDefaultMapView__bounds__row">
                        <RotatableBoundingRect rotation={90} />
                        <RotatableBoundingRect rotation={0} />
                    </div>
                </div>
                <div className="SetDefaultMapView__form_container">
                    <div className="SetDefaultMapView__form">
                        <h4>Set starting map view</h4>
                        <p>
                            Set the best angle to view your farm, then click Save View when you are
                            ready. This will be the default view when you start next time, or click
                            the home icon.
                        </p>
                        <p>
                            <ul>
                                <li>Zoom in/out: Use your mouse scroll wheel or +/- buttons</li>
                                <li>Pan around: Click and drag the map</li>
                                <li>Tilt view: Hold Ctrl and drag up/down</li>
                                <li>Rotate view: Hold Ctrl and drag left/right</li>
                            </ul>
                        </p>
                        <div className="SetDefaultMapView__form__buttons">
                            <Button
                                className="SetDefaultMapView__form__buttons-cancel"
                                text="Cancel"
                                variant="outlined"
                                onClick={() => {
                                    navigate(farmPath('/'));
                                }}
                            />

                            <Button
                                text="Save View"
                                variant="contained"
                                onClick={() => {
                                    updateFarm.mutate(getViewerPosition(mapService.viewer), {
                                        onSuccess: () => {
                                            void agricultureToastService.showToast({
                                                title: 'Starting view updated',
                                                type: AgricultureToastType.SUCCESS,
                                                variant: 'simple',
                                            });
                                            navigate(farmPath('/'));
                                        },
                                    });
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Portal>
    );
}
